import Service from "../Service";

const banner = {

    getAllBanners() {
        return Service.get(`/api/banners/all`);
    }

};

export default banner;
